var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.42408 6.39386C9.7588 6.39386 10.0301 6.6652 10.0301 6.99992C10.0301 7.33464 9.7588 7.60598 9.42408 7.60598H4.57559C4.24088 7.60598 3.96953 7.33464 3.96953 6.99992C3.96953 6.6652 4.24088 6.39386 4.57559 6.39386H9.42408Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.33317 6.99992C0.33317 10.6818 3.31794 13.6666 6.99984 13.6666C10.6817 13.6666 13.6665 10.6818 13.6665 6.99992C13.6665 3.31802 10.6817 0.333252 6.99984 0.333252C3.31794 0.333252 0.33317 3.31802 0.33317 6.99992ZM1.54529 6.99992C1.54529 10.0124 3.98737 12.4545 6.99984 12.4545C10.0123 12.4545 12.4544 10.0124 12.4544 6.99992C12.4544 3.98746 10.0123 1.54537 6.99984 1.54537C3.98737 1.54537 1.54529 3.98746 1.54529 6.99992Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircle);
export default __webpack_public_path__ + "static/media/minus-circle.9613123aa50008b14c1b202aab903622.svg";
export { ForwardRef as ReactComponent };